<template>
  <div v-if="file" class="hstack gap-2">
    <div v-if="file?.exists" class="form-control-plaintext">
      <a class="hstack" :href="downloadLink(file)" :download="file.name">
        <i class="bi bi-file-earmark-fill me-2" />
        {{ file.name }}
      </a>
    </div>

    <div v-else class="form-control disabled hstack">
      <i class="bi bi-file-earmark-fill me-2" />
      {{ file?.name }}
    </div>
    <button v-if="file?.exists" type="button" class="btn btn-light btn-sm" @click="$emit('remove')">
      <i class="bi bi-trash" />
    </button>
    <button v-else-if="delayed" class="btn btn-light btn-sm" type="button" @click="$emit('upload')">
      <i class="bi bi-upload" />
    </button>
  </div>
</template>
<script setup>
defineProps({
  file: Object,
  delayed: {
    type: Boolean,
    default: false,
  },
  downloadLink: Function,
})
defineEmits(['remove', 'upload'])
</script>
